module.exports = __webpack_public_path__ + "img/login_ic_postbox.489c2c5.png";